//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SidebarItem from './SidebarItem'
export default {
  name: "SidebarItem",
  data() {
      return {
      };
  },
  components: {
    SidebarItem,
  },

  props: ["data"],
  methods: {
    //弹出新页面，有限制长宽，target=1
    openWindow(href,menuid) {
      let query = {};
      query.pd = menuid;
      this.openWin(href,query);
    },
    //在Layout中显示页面，target=0
    openLayout(href,menuid) {
      let timestamp = Date.parse(new Date()) / 1000;
      this.$store.state.timestamp = timestamp;
      this.$router.push({
        path:href,
        query:{pd:menuid}
      })
    },
    //弹出新页面，无限制长宽，target=2
    openNewPage(href,menuid) {
      let routeUrl = this.$router.resolve({
          path: href,
          query: {pd:menuid}
      });
      window.open(routeUrl.href, "_blank");
    },
  },
  created(){
  }
};



// WEBPACK FOOTER //
// ./src/pccomponents/SidebarItem.vue